import axiosPrivate from "@services/axiosPrivate"

export const contactSupport = async (data) => {
    const response = await axiosPrivate.post(`vision/contact-support`, data)
    return response
}